import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

/**
 * H-106: DB-backed admin check.
 * Reads `user_settings.role` for the current auth user.
 * Returns `{ isAdmin, loading }`.
 */
export function useIsAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!supabase) {
      setLoading(false);
      return;
    }

    // Capture a non-null reference so the closure below doesn't have to
    // re-narrow `supabase` after each await.
    const sb = supabase;
    let cancelled = false;

    const check = async () => {
      const { data: { session } } = await sb.auth.getSession();
      if (cancelled) return;

      if (!session?.user?.id) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      const { data } = await sb
        .from('user_settings')
        .select('role')
        .eq('user_id', session.user.id)
        .maybeSingle();

      if (!cancelled) {
        setIsAdmin(data?.role === 'admin');
        setLoading(false);
      }
    };

    check();

    return () => { cancelled = true; };
  }, []);

  return { isAdmin, loading };
}
